export const postFixMobile ='Mobile';

export const isMobilePath =(path:string)=>{
    if (path.includes(postFixMobile))
        return true;
    return false;
}